import {
  IonInput,
  IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption,
} from '@ionic/react';
import React, { useEffect, useState, useMemo } from 'react';
import classes from './styles.module.scss';
import { codes as countryCodes } from '../../../utils/countryCodes';

interface ContactCardProps {
  title: string;
  name: string;
  formValues: Record<string, any>;
  className?: string;
  value: (updateFn: (form: any) => any) => void;
}

const ContactCard: React.FC<ContactCardProps> = ({
  title,
  name,
  formValues,
  className = '',
  value: onFormUpdate,
}) => {
  const uganda = useMemo(
    () => countryCodes.find((code) => code.name === 'Uganda'),
    []
  );
  const [showHelperText, setShowHelperText] = useState<boolean>(false)

  const [selectedCountry, setSelectedCountry] = useState(uganda);

  const displayValue = useMemo(() => {
    if (!formValues?.[name]) return '';

    const fullNumber:string = formValues[name] || '';
    const dialCode = selectedCountry?.dial_code?.replace(/^\+/, '') || '';

    if (fullNumber.startsWith(dialCode)) {
      return fullNumber.substring(dialCode.length);
    }

    return fullNumber.replace(/^\+/, '');
  }, [formValues, name, selectedCountry?.dial_code]);

  const onInputChange = (txt: string) => {
    if (!selectedCountry?.dial_code) return;

    let cleanedInput = txt.replace(/\D/g, '').replace(/^0+/, '').trim();

    const fullNumber = cleanedInput ? `${selectedCountry.dial_code}${cleanedInput}`.replace(
      /^\+/,
      ''
    ) : '';

    onFormUpdate((form: any) => ({
      ...form,
      [name]: fullNumber,
    }));
  };

  const onCountryChange = (newDialCode: string) => {
    const newCountry = countryCodes.find(
      (country) => country.dial_code === newDialCode
    );

    if (newCountry) {
      setSelectedCountry(newCountry);

      const currentDisplayValue = displayValue.trim();
      const newFullNumber = currentDisplayValue ? `${newCountry.dial_code}${currentDisplayValue}`.replace(/^\+/, '') : '';

      onFormUpdate((form: any) => ({
        ...form,
        [name]: newFullNumber,
      }));
    }
  };

  return (
    <div className={`${classes.countryCard} px-3 ${className}`}>
      <IonItem lines="none">
        <IonLabel>{`${selectedCountry?.code} ${selectedCountry?.dial_code}`}</IonLabel>
        <IonSelect
          value={selectedCountry?.dial_code}
          onIonChange={(e) => onCountryChange(e.detail.value)}
        >
          {countryCodes.map((country) => (
            <IonSelectOption key={country.name} value={country.dial_code}>
              {`${country.code} ${country.name} (${country.dial_code})`}
            </IonSelectOption>
          ))}
        </IonSelect>
        <IonInput
          value={displayValue}
          type="tel"
          placeholder={title}
          name={name}
          color="primary"
          maxlength={9}
          onBlur={()=>setShowHelperText(false)}
          onFocus={()=>setShowHelperText(true)}
          onIonChange={(e) => onInputChange(e.detail.value || '')}
        />
      </IonItem>
     {showHelperText && <div className={'w-full text-gray-500 text-xs my-1'}>Add your number without the first zero ex: 0771234567 fill in 771234567 </div>}
    </div>
  );
};

export default ContactCard;
